import React, { useState, useEffect } from 'react';
import ActionButtonCard from '../Button/ActionButtonCard';
import Swal from 'sweetalert2'
import { Form, Button, Card, InputGroup, FormControl } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';


function SelecionarCategoriaProduto({categoriaId, setCategoriaId, defaultText, label, adicionalText, adicionalValue}) {
  const [categorias, setCategorias] = useState([]);
  
  const { 
    crudAdmin,
    buscarDados,
    salvarDados,
  } = useProvider();
  const { get } = crudAdmin || {};

  

  const buscarCategoriaProdutoLocal = async () => {
    try{
      const response = await buscarDados(
        "db_categorias",
        (item) => {
          return item.tipo === "produtos"
        },
        100,
        "nome_da_categoria",
      )
      if (response && response.length){
        setCategorias(response);
      }
    }catch(err){

    }finally{
      buscarCategoriaProduto();
    }
  };
  const buscarCategoriaProduto = async () => {
    try{
      const response = await get(`/gvendas/categorias/?ordering=nome_da_categoria&tipo__in=produtos&expand=categoria_pai`, 'SelecionarCategoriaProduto');
      if (response && response.length){
        setCategorias(response[0].results);
        await salvarDados("db_categorias", response[0].results);
      }
    }catch(err){

    }finally{
      
    }
  };
  

  useEffect(() => {
    buscarCategoriaProdutoLocal();
  }, [setCategorias]);

  return (
    <>
      <Form.Group controlId="formCategoria" className="mt-3">
        <div className="input-group">
          <span className="input-group-text">{label || 'Categoria'}</span>
          <Form.Control 
            as="select" 
            value={categoriaId} 
            onChange={(e) => setCategoriaId(e.target.value)}
          >
            {/* Supondo que você tenha um array de categorias para mapear */}
              <option value="">{defaultText || 'Selecione uma categoria'}</option>
            {/* Categorias mapeadas aqui */}
            {categorias?.length > 0 ? (categorias.map((item) => 
              <option value={item.id}>{item.categoria_pai && (<>
                {item.categoria_pai?.nome_da_categoria}{` > `}
              </>)}
              {item.nome_da_categoria}</option>
            )) : ''}
            {adicionalText &&
            (<option value={adicionalValue}>{adicionalText || 'Categoria Adicional'}</option>)}
          </Form.Control>
        </div>
      </Form.Group>
    </>
  );
}

export default SelecionarCategoriaProduto;